// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"tabsContainer-1LxhJ tabsContainer-1cvC0","tab":"tab-1Dyqu tab-1ENf3","tabActive":"tabActive-3yszo tabActive-2OFvo"};